const FONT_STYLESHEET_ID = "zskstat-outfit-font";
const OUTFIT_CSS_URL =
   "https://fonts.googleapis.com/css2?family=Outfit:ital,wght@0,100..900;1,100..900&display=swap";

/**
 * Ładuje Outfit z Google Fonts (preconnect + stylesheet). Bezpieczne przy wielokrotnym wywołaniu.
 * @returns {Promise<void>}
 */
export function loadOutfitFont() {
   if (typeof document === "undefined") {
      return Promise.resolve();
   }

   const existing = document.getElementById(FONT_STYLESHEET_ID);
   if (existing) {
      return document.fonts?.ready ?? Promise.resolve();
   }

   const append = (el) => document.head.appendChild(el);

   const preGoogle = document.createElement("link");
   preGoogle.rel = "preconnect";
   preGoogle.href = "https://fonts.googleapis.com";
   append(preGoogle);

   const preGstatic = document.createElement("link");
   preGstatic.rel = "preconnect";
   preGstatic.href = "https://fonts.gstatic.com";
   preGstatic.crossOrigin = "anonymous";
   append(preGstatic);

   return new Promise((resolve) => {
      const link = document.createElement("link");
      link.id = FONT_STYLESHEET_ID;
      link.rel = "stylesheet";
      link.href = OUTFIT_CSS_URL;
      link.onload = () => {
         if (document.fonts?.ready) {
            document.fonts.ready.then(() => resolve()).catch(() => resolve());
         } else {
            resolve();
         }
      };
      link.onerror = () => resolve();
      append(link);
   });
}
